// extracted by mini-css-extract-plugin
export default {"option":"RadioCardGroup_option__x8J1I","right":"RadioCardGroup_right__Vucra"};